module.exports = __webpack_public_path__ + "static/media/45GovernorsFlowers.b7c85d6f.jpg";